export default __webpack_public_path__ + "static/media/grid14.06743050.png";